import { Icon } from "@components/icons/Icon";
// import { LanguageSwitcher } from "@components/shared/language-switcher/LanguageSwitcher";
import cn from "classnames";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Logo } from "./Logo";
import styles from "./Nav.module.scss";

type NavLink = { label: string; href: string };

export function Nav() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const links = t("nav.links", { returnObjects: true }) as NavLink[];
  const brand = t("common.brand");
  const cta = t("common.cta");

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header
        className={styles.navBase}
        style={
          scrolled
            ? {
                background: "rgba(255,255,255,0.86)",
                backdropFilter: "saturate(140%) blur(12px)",
                WebkitBackdropFilter: "saturate(140%) blur(12px)",
                borderBottom: "1px solid var(--line)",
              }
            : undefined
        }
      >
        <div className={styles.navInner}>
          <a href="#top" className={cn(styles.brandLink, scrolled && styles.brandLinkScrolled)}>
            <Logo color={scrolled ? "var(--accent)" : "#fff"} />
            {brand}
          </a>
          <nav className={styles.navLinks}>
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: scrolled ? "var(--fg-2)" : "rgba(255,255,255,0.85)",
                  transition: "color 0.18s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = scrolled ? "var(--accent)" : "#fff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = scrolled
                    ? "var(--fg-2)"
                    : "rgba(255,255,255,0.85)")
                }
              >
                {link.label}
              </a>
            ))}
            <div
              style={{
                color: scrolled ? "var(--fg-2)" : "rgba(255,255,255,0.85)",
                transition: "color 0.18s ease",
              }}
            >
              {/* <LanguageSwitcher variant="desktop" /> */}
            </div>
          </nav>
          <button
            className={cn(styles.hamb, scrolled && styles.hambScrolled)}
            aria-label={t("common.menu")}
            onClick={() => setOpen(!open)}
          >
            {open ? <Icon.x s={22} /> : <Icon.menu s={22} />}
          </button>
        </div>
      </header>

      <div className={cn(styles.mobOverlay, open && styles.mobOverlayOpen)}>
        <div className={styles.mobHeader}>
          <a href="#top" className={styles.mobBrandLink} onClick={() => setOpen(false)}>
            <Logo color="var(--accent)" />
            {brand}
          </a>
          <button
            onClick={() => setOpen(false)}
            className={styles.mobCloseBtn}
            aria-label={t("common.close")}
          >
            <Icon.x s={22} />
          </button>
        </div>
        <div className={styles.mobBody}>
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className={styles.mobNavLink}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className={`btn btn-primary ${styles.mobCta}`}
          >
            {cta} <span className="arr">→</span>
          </a>
          {/* <LanguageSwitcher variant="mobile" onSelect={() => setOpen(false)} /> */}
        </div>
      </div>
    </>
  );
}
